import React, {CSSProperties} from "react";
import Img from "gatsby-image";
import {graphql, useStaticQuery} from "gatsby";


interface GimageProps{
    src:string;
    style?:CSSProperties;
}

const Gimage:React.FC<GimageProps> = (props) => {
    const data = useStaticQuery(
        graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `
    );
    return(
        // @ts-ignore
        <Img fluid={data.images.edges.find(n => {return n.node.relativePath.includes(props.src);}).node.childImageSharp.fluid} alt={"Test Fluid"} style={props.style}/>
    )
}

export default Gimage;